import type {BankAccount} from "@/scripts/Common";

const createEmptyBankAccount = () => {
    const bankAccount: BankAccount = {
        id: 0,
        creditInstitute: '',
        iban: '',
        bic: '',
        accountOwnerName: ''
    }

    return bankAccount;
}

const resetBankAccountObject = (originalObject: BankAccount, changedObject: BankAccount) => {
    changedObject.id = originalObject.id;
    changedObject.creditInstitute = originalObject.creditInstitute;
    changedObject.iban = originalObject.iban;
    changedObject.bic = originalObject.bic;
    changedObject.accountOwnerName = originalObject.accountOwnerName;
}

const bankAccountHasChanges = (originalObject: BankAccount | undefined | null, changedObject: BankAccount | undefined | null) => {
    if(!originalObject || !changedObject){
        return !(!originalObject && !changedObject); // both are empty means no changes
    }

    return changedObject.id !== originalObject.id
        || changedObject.creditInstitute !== originalObject.creditInstitute
        || changedObject.iban !== originalObject.iban
        || changedObject.bic !== originalObject.bic
        || changedObject.accountOwnerName !== originalObject.accountOwnerName;
}

export {
    createEmptyBankAccount,
    resetBankAccountObject,
    bankAccountHasChanges
}
